import * as React from "react";
import { Select } from "antd";
import { onError } from "src/common/onError";
import { Bom2aEdPositionRow, bom2aUiSize } from "../../Bom2aPositionsTypes";
import { Bom2aPositionsStore } from "../../Bom2aPositionsStore";
import { saveBom2aFields } from "../../apiBom2aPositions";

interface PropsBom2aMaterialCell {
  row: Bom2aEdPositionRow;
  store: Bom2aPositionsStore;
}

export const Bom2aMaterialCell: React.FC<PropsBom2aMaterialCell> = (props) => {
  const { row, store } = props;
  const { materialCategory } = row;
  return (
    <Select
      options={materialCategory.options}
      fieldNames={{
        label: "name",
        value: "dictId",
      }}
      value={materialCategory.dictId as string}
      onChange={(value) => {
        store
          .updateTask(async () => {
            await saveBom2aFields({
              id: String(row.id),
              fields: [
                {
                  id: String(materialCategory.fieldId),
                  value: value || null,
                },
              ],
            });
          })
          .catch(onError);
      }}
      allowClear
      size={bom2aUiSize}
      style={{ width: "100%" }}
    />
  );
};
